<template>
    <!-- 银行卡选择( 基金交易时 ) -->
    <div class="wk-input wk-input-box dropDown-bank-box posi-relative">
        <span class="input-left-label">{{label}}</span>
        <!--下拉框的 显示框-->
        <div class="dropDown-title dropDown-bank posi-relative" @click="titleCliCk" 
            :class="{'limit-height':isShowLimit,'limit-height-more':subscribeState==1&&bankInfo.singleLimit}">
            <!-- 如果已经选择的某个银行 -->
            <template v-if="bankInfo.bankCode" >
                <img :src="imgUrl+'static/img/bank-icon/'+bankInfo.bankCode+'.png'" 
                    class="dropDown-title-icon dropDown-bank"/>
                <p class="dropDown-title-bankName ft-size-16 dropDown-bank">
                    {{bankInfo.bankName}} | {{bankInfo.bankAcco.substr('-4')}}
                </p>
            </template>
            <!-- 否则 未选择 提示请选择开户行 -->
            <p v-else class="dropDown-title-placeholder ft-size-16 dropDown-bank">
                {{!placeholder ? '请选择开户行' : placeholder}}</p>
            <!-- 可用份额 或是 日限额提示 -->
            <p v-if='isShowLimit && showTip !== ""' class="limit txt-gray-g"> {{limitTxt}} </p>   
            <!-- 在 readonly 下 启用 -->
            <p v-if="readonly===''" class="disabled posi-absolute"></p>
            <!-- 尾部 三角号 icon -->
            <p class="posi-absolute dropDown-title-sanjiao dropDown-bank">
                <img src="../../assets/img/dropdow-icon.png" class="dropDown-title-sanjiao dropDown-bank">
            </p>
        </div>
        <!--下拉框的选项-->
        <ul v-if="isShowBox" class="dropDown-item-list posi-absolute dropDown-bank" :style="styleCpt">
            <li v-for="(item,k) in bankList" @click="itemClick(k)" :key='k' 
                :class="{active:k===bankIndex}" class="dropDown-item"> 
                <p class="dropDown-item">  
                    <!-- <img class="dropDown-item" v-if="!strUrl" :src="'./static/img/bank-icon/'+item.bankCode+'.png'"/> 
                    <img class="dropDown-item" v-else :src="strUrl + './static/img/bank-icon/'+item.bankCode+'.png'"/>  -->
                    <img class="dropDown-item" :src="imgUrl + 'static/img/bank-icon/'+item.bankCode+'.png'"/>
                </p>
                <p class="dropDown-item" v-if="item.bankAcco">{{item.bankName}} | {{item.bankAcco.substr(-4)}}</p>
                <p class="dropDown-item" v-else>{{item.bankInfo}}</p>
            </li>
            <li v-if="bankList.length < 1  " class="dropDown-item flex-jf-center no-data"> 
                <p class="dropDown-item "> 暂无数据 </p>
            </li>
        </ul>
    </div>			
</template>

<script>
    export default {
        props: ['label','value','id','styleCpt','readonly','dataList','subscribeState',
            'showTip','placeholder','strUrl','isAppointment'],
        mounted(){
            this.initHandler(this);
        },
        data(){
            return{
                imgUrl:process.env.ASSETS_PUBLICPATH,
                bankList:'',
                bankInfo:'',
                bankIndex:'',
                isShowBox:false,
                limitTxt:'',//限额提示
                isShowLimit:false//是否想显示限额
            }
        },
        watch:{
            value(){
                // 一般是回显会用到
                if(this.bankInfo === '' && this.bankList){
                    this.showSltBank(this);
                }
            },
            dataList(){
                // console.log(this.dataList)
                this.dataList ? this.bankList = this.dataList : this.bankList = [];
                if(this.dataList.length > 0){
                    console.log('this.dataList',this.bankList)
                    this.itemClick(0);
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener('click', this.windowHanlderOfBank);
        },
        methods:{
            // title 单击事件
            titleCliCk(){
                this.isShowBox = !this.isShowBox;
            },
            // 银行选择事件
            itemClick(k){
                this.bankIndex = k;
                this.bankInfo = this.bankList[k];
                this.isShowBox = false;
                this.limitTxt = '暂无可用份额' 
                // 如果是薪意保支付
                if(this.bankInfo.usableShare){
                    this.limitTxt = '可用份额：' + this.$tools.Separator(this.bankInfo.usableShare) + '份';
                    if(this.isAppointment === ''){
                        this.limitTxt = '当前' + this.limitTxt ;
                    }
                    // this.isShowLimit = true; // 因为不确定有没有,所以写在里面
                }else if(this.bankInfo.dayLimit && this.bankInfo.dayLimit){
                    // 如果是认购
                    if(this.subscribeState == 1){
                        let singleLimit = '单笔限额' + this.$tools.Separator(this.bankInfo.singleLimit) + '元',
                            dayLimit = '单日限额' + this.bankInfo.dayLimit + '元',
                            monthLimit = '单月限额' + this.bankInfo.monthLimit + '元';
                        if(this.bankInfo.singleLimit && this.bankInfo.dayLimit && this.bankInfo.monthLimit){
                            this.limitTxt = singleLimit + '，' + dayLimit + '，' + monthLimit;
                        }else if(this.bankInfo.singleLimit){
                            this.limitTxt = singleLimit;
                            if(this.bankInfo.dayLimit){
                                this.limitTxt +='，' + dayLimit;
                            }else if(this.bankInfo.monthLimit){
                                this.limitTxt +='，' +  monthLimit;
                            }
                        }else if(this.bankInfo.dayLimit){
                            this.limitTxt = dayLimit;
                            if(this.bankInfo.monthLimit){
                                this.limitTxt += '，' + monthLimit;
                            }
                        }else if(this.bankInfo.monthLimit){
                            this.limitTxt = monthLimit;
                        }
                        
                        //+ '(请您以开户银行以及您在开户银行网银设定的限额为准)';
                    }else{
                        let dayLimit = '每日限额：' + this.bankInfo.dayLimit + '元', monthLimit = '每月限额：' + this.bankInfo.monthLimit + '元';     
                        if(this.bankInfo.dayLimit && this.bankInfo.monthLimit){
                            this.limitTxt = dayLimit + '，' + monthLimit;
                        }else if(this.bankInfo.dayLimit){
                            this.limitTxt = dayLimit;
                        }else if(this.bankInfo.monthLimit){
                            this.limitTxt = monthLimit;
                        }
                    }
                }
                this.isShowLimit = true; // 因为不确定有没有,所以写在里面
                this.$emit('input',this.bankInfo);
                this.$emit('change',k);
            },
            // 清空已选择的值
            clearSltVal(){
                this.bankIndex = '';
                this.bankInfo = '';
            },
            // window 点击事件
            windowHanlderOfBank(e){
                let target = e.target;
                // 如果点击的 不是 title 和 item 都隐藏
                if( target.className.indexOf('dropDown-bank') < 0 ){
                    this.isShowBox = false;
                }
            },
            // 页面初始化数据
            initHandler(that){
                this.dataList ? this.bankList = this.dataList : this.bankList = [];
                // 绑定 window 事件
                window.addEventListener('click', this.windowHanlderOfBank);
            },
            // 显示的默认选中的银行卡信息
            showSltBank(that){
                if(that.value){
                    // 遍历出当前的 默认选中的 银行卡信息
                    that.bankList.map((val,k)=>{
                        if(val.bankCode == that.value.bankCode){
                            that.bankIndex = k;
                            that.bankInfo = val;
                            //跟新 当前银行卡的 开户方式
                            that.$store.commit('upBankInfo',{capitalInfoList:val.capitalInfoList})
                        }
                    })                              
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .dropDown-bank-box{
        margin:.9rem 0;
        // 下拉框的 title
        .dropDown-title{
            width: 17.3rem;
            height: 2.1rem;
            padding:0 .8rem;
            line-height: 2rem;
            border: 1px solid #d1d1d1;
            cursor:pointer; 
            // 未选择时提示
            .dropDown-title-placeholder{
                color:#cacaca;
            }
            // 已选择的银行 名称
            .dropDown-title-bankName{
                position: absolute;
                top:0;
                left:2.5rem;
            }
            // 已选择的银行 icon
            .dropDown-title-icon{
                max-width:1.2rem;
                margin-top:.4rem;  
            }
            // readonly 下启用
            p.disabled{
                top:0;
                right:0;
                width:18.4rem;
                height:2rem;
                background:rgba(245, 247, 250, .1);
                z-index: 3;
            }
            p.limit{
                width:110%;
                margin-left:-.7rem;
                line-height: 1.05rem;
            }
            // 三角号的icon
            p:last-child{
                top:0;
                right:0;
                bottom:0;
                width:2rem;
                background: #F8F8F8;
                border-left:.05rem solid #D6D6D6;
                text-align: center;
            }
        }
        // 显示 限额 或 可用份额时显示
        .limit-height{ 
            margin-bottom:.9rem;
        }
        // 显示 限额 或 可用份额时显示 (字数更多) 
        .limit-height-more{
            margin-bottom:2rem;
        }
        // 下拉选择项
        .dropDown-item-list{
            top:2.5rem;
            right:-1.1rem;
            width: 19.6rem;
            // min-height:100px;
            padding:0 0 0;
            flex-wrap: wrap;
            background: #fff;
            box-shadow:0 2px 9px 0 rgba(205,200,200,0.48);
            z-index: 2;
            li{
                display:flex !important;
                height: 2.3rem;
                padding:0 .4rem;
                margin:0 0 0 0;
                border:.05rem solid transparent;
                border-left:.05rem solid #D1D1D1;
                border-right:.05rem solid #D1D1D1;
                cursor: pointer;
                transition: all .5s linear;
                // 银行 icon
                p:first-child{
                    padding-right:.3rem;
                    img{
                        max-width: 1.2rem;
                        margin-top:.55rem;
                    }
                }
                // 银行 名称
                p:last-child{
                    line-height: 2.3rem;
                }
            }
            li + li,li:first-child{
                border-top:.05rem solid #D1D1D1;
            } 
            li:last-child{
                border-bottom:.05rem solid #D1D1D1;
            } 
            li:nth-child(3n){
                margin-right:0;
            }
            li.no-data,li.no-data:hover{
                background: #f5f5f5  !important;
                color:#999;
                border:.05rem solid #D1D1D1;
            }
            li:hover,li.active{
                border:.05rem solid #DD867E;
                background:#FFF0EE;
            }
            li:hover + li,li.active + li{
                border-top:.05rem solid transparent;
            }
        }
    }
</style>
<style lang="less">
   .container-two .dropDown-bank-box {
       .dropDown-item-list{
           right:-2.3rem;
       }
   }
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/wkSelectBankFund.vue